<template>
  <div>
    <v-carousel v-model="model" height="100vh" hide-delimiters>
      <v-carousel-item v-for="(item, index) in items" :key="index">
        <v-row justify="center">
          <v-img
            class="white--text align-end"
            height="100vh"
            style="position:fixed;"
            :src="require(`../../../../styles/${item}`)"
          >
            <v-card-title
              class="justify-center"
              style="background-color:rgba(0,0,0,0.5);padding-bottom:0;"
              >{{ description[index] }}</v-card-title
            >
            <v-card-title
              class="justify-center"
              style="background-color:rgba(0,0,0,0.5); padding-top:0;"
              >{{ index + 1 }}|{{ quant }}</v-card-title
            >
          </v-img>
          <v-col>
            <v-btn fab class="ml-3" onClick="history.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      number: this.$route.query.num,
      items: this.$route.query.item,
      description: this.$route.query.description,
      model: this.$route.query.num - 0,
      quant: this.$route.query.item.length
    };
  }
};
</script>

<style scoped></style>
